'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader
const verihub = ENV.verihub

const actions = {
  getLogAll(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/log/findall`
        const result = await axios.get(url, {
          ...costumHeader('Get Log All', 4),
          params,
          timeout: 15000
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getCleansingHistory(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `https://cleansingvpc-fbilvsldzq-as.a.run.app/data/cleansing`
        const result = await axios.get(url, {
          ...costumHeader('Get Cleansing by Company', 4),
          params,
        })
        if (result) if (result.data) if (result.status == 200) return resolve(result.data)
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  cleansingManual(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `https://cleansingvpc-fbilvsldzq-as.a.run.app/auto/cleansing`
        const result = await axios.get(url, {
          ...costumHeader('Get Cleansing Manual', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) { 
          context.dispatch('nShowMessage', {type: 'success', msg: result.data.message})
          return resolve(result.data.data)
        }
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  runCleansing(context, params = {}) {
    const defaultData = []
    return new Promise(async (resolve) => {
      try {
        const url = `https://us-central1-appsensi-dev.cloudfunctions.net/attendance_all_company`
        const result = await axios.get(url, {
          ...costumHeader('Get Log All', 4),
          params,
          timeout: 15000
        })
        if (result) if (result.data) if (result.data.code == 200) { 
          context.dispatch('nShowMessage', {type: 'success', msg: result.data.message})
          return resolve(result.data.data)
        }
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },

  deleteUserFace(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${verihub.url}/v1/face/enroll?subject_id=Appsensi_${params.companyId}_${params.userId}`
        const result = await axios.delete(url, {headers: {'API-Key': verihub.key, 'App-ID': verihub.id}
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteUser(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/delete`
        const result = await axios.post(url, body, costumHeader('Delete User', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
}

export default { actions }